fragment StaffTrainingModuleSummaryFields on StaffTrainingModuleSummary {
  id
  slug
  title
  controlReference
  durationLabel
  hasVideo
  hasQuiz
  locked
  posterUrl
  status
  dueOn
  daysLeft
  bestScore
  passedAt
  expiresOn
}
